import { useEffect, useState } from 'react'

/**
 * Возвращает значение с задержкой, обновляется только после паузы
 * @param value - исходное значение
 * @param delay - задержка в миллисекундах (по умолчанию 300мс)
 */
export function useDebounce<T>(value: T, delay = 300): T {
  const [debouncedValue, setDebouncedValue] = useState(value)

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedValue(value)
    }, delay)

    return () => {
      clearTimeout(timer)
    }
  }, [value, delay])

  return debouncedValue
}
